import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import NewInsurance from "./NewInsuranceApplication/NewInsurance";
import InsuranceCancellation from "./InsuranceCancellation/InsuranceCancellation";

export default function Insurance() {
  //screen Title Show fun
  const dispatch = useDispatch();
  const titleBorder = [{ label: "Insurance", link: "/dashboard/AtmPayroll" }];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [index, setIndex] = useState(0);

  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            className={`p-2 m-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
            onClick={() => handleIndex(0)}
          >
            New Insurance Application
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-2 m-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            Insurance Cancellation Application
          </button>
        </div>
        {index === 0 ? (
          <NewInsurance />
        ) : index === 1 ? (
          <InsuranceCancellation />
        ) : index === 2 ? (
          <></>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
